import styled, { css } from "styled-components";

import Small from "../../atoms/Typography/Small";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const DocumentBox = styled.div`
  gap: 32px;
  width: 100%;
  display: flex;

  @media (max-width: 750px) {
    align-items: center;
    flex-direction: column;
  }
`;

type ColorProps = {
  borderColor: string;
  backgroundColor?: string;
};

export const ButtonUploadImage = styled.div<ColorProps>`
  ${({ borderColor, backgroundColor }) => css`
    gap: 20px;
    width: 300px;
    height: 200px;
    display: flex;
    cursor: pointer;
    margin-top: 1rem;
    overflow: hidden;
    position: relative;
    text-align: center;
    border-radius: 24px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border: 1px dashed ${borderColor};
    background-color: ${backgroundColor};

    @media (max-width: 760px) {
      width: 100%;
    }

    @media (max-width: 420px) {
      height: 160px;
    }

    input {
      top: 0;
      left: 0;
      right: 0;
      opacity: 0;
      z-index: 99;
      height: 100%;
      cursor: pointer;
      -moz-opacity: 0;
      position: absolute;
      filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);
    }
  `}
`;

export const PlusIcon = styled.div<ColorProps>`
  ${({ borderColor }) => css`
    width: 52px;
    height: 52px;
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    border: 1px dashed ${borderColor};

    svg {
      width: 60%;
      height: 60%;
    }
  `}
`;

export const Error = styled(Small)`
  display: flex;
  margin-top: 1rem;
`;

export const UploadedDocument = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
`;

export const Icon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;
